.container {
  border-radius: 6px;
  box-shadow: 2px 2px 8px #666;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkltYWdlU2hvdy5zYXNzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi5jb250YWluZXJcbiAgYm9yZGVyLXJhZGl1czogNnB4XG4gIGJveC1zaGFkb3c6IDJweCAycHggOHB4ICM2NjZcbiJdfQ== */